import React, {useContext, useEffect} from "react";
import {Link} from "react-router-dom";
import Header from "../../components/header/Header";
import StyleContext from "../../contexts/StyleContext";
import PrivateSpace from "./PrivateSpace";
import "./PrivatePage.scss";

/** Standalone /private page — the portfolio sections are deliberately absent. */
export default function PrivatePage() {
  const {isDark} = useContext(StyleContext);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Private Space";
    window.scrollTo(0, 0);
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <div className={isDark ? "private-page dark-mode" : "private-page"}>
      <Header />
      <main className="private-page-body">
        <PrivateSpace />
      </main>
      <footer className="private-page-footer">
        <Link to="/" className="private-back-link">
          &larr; Back to portfolio
        </Link>
      </footer>
    </div>
  );
}
